import { useState } from "react";
import { Form } from "react-bootstrap";
import EntityManager from "./EntityManager.jsx";
import QuoteTemplatesManager from "./QuoteTemplatesManager.jsx";

// Order Fee Profiles — the Do & Charge panel's presets on ONE tab (KS
// 2026-08-26 §1, built 2026-09-05): the profile cascade grid (WHO gets which
// rates — order_fee_profiles) and, behind the same "Show" radio Quote Fee
// Profiles uses, the five order registries (what each generated invoice line
// SAYS and its standard rate — the templates manager in its "orderFees"
// mode). The pair is the quote pair's mirror on purpose: one model to learn,
// two tables so orders and quotes can diverge without hacks.
const VIEWS = [
  { key: "profiles", label: "Order Fee Profiles" },
  { key: "rates", label: "Standard rates and wording" },
];

function OrderFeeProfilesPanel({ entity, canWrite, includeInactive, initialEditId, onDeepLinkDone }) {
  const [view, setView] = useState("profiles");
  return (
    <>
      <div className="d-flex flex-wrap align-items-center column-gap-4 row-gap-1 mb-3">
        <span className="text-uppercase fw-semibold small text-muted" style={{ letterSpacing: "0.06em" }}>
          Show
        </span>
        {VIEWS.map((v) => (
          <Form.Check
            key={v.key}
            inline type="radio" id={`ofp-view-${v.key}`} name="ofp-view"
            label={v.label}
            checked={view === v.key}
            onChange={() => setView(v.key)}
            className="me-0"
          />
        ))}
      </div>
      {view === "profiles" ? (
        <EntityManager
          entity={entity}
          includeInactive={includeInactive}
          initialEditId={initialEditId}
          onDeepLinkDone={onDeepLinkDone}
        />
      ) : (
        <QuoteTemplatesManager mode="orderFees" canWrite={canWrite} />
      )}
    </>
  );
}

export default OrderFeeProfilesPanel;
